import { useDispatch } from "react-redux";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { addAlertEvent } from "app/store/slice/events/event";

let notificationSequence = 0;

const useNotification = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const dispatchEvent = useCallback(
        (key: string, message: string, type: "success" | "error" | "info" | "warning") => {
            const name = `${key}-${Date.now()}-${++notificationSequence}`;
            dispatch(
                addAlertEvent({
                    name,
                    message: String(t(key, { defaultValue: message, fallbackLng: [] })),
                    type,
                })
            );
        },
        [dispatch, t]
    );

    const alert = useCallback((key: string, message: string) => {
        dispatchEvent(key, message, "error");
    }, [dispatchEvent]);

    const warning = useCallback((key: string, message: string) => {
        dispatchEvent(key, message, "warning");
    }, [dispatchEvent]);

    const success = useCallback((key: string, message: string) => {
        dispatchEvent(key, message, "success");
    }, [dispatchEvent]);

    const info = useCallback((key: string, message: string) => {
        dispatchEvent(key, message, "info");
    }, [dispatchEvent]);

    return useMemo(() => ({
        alert,
        warning,
        success,
        info
    }), [alert, warning, success, info]);
};

export default useNotification;
